// EN + ES copy for BrowsEMS — South Florida microblading studio.
export const translations = {
    en: {
        promo: "South Florida's Master Studio · Microblading · Microshading · Lip Blush",
        nav: {
            services: "Services",
            artists: "Artists",
            gallery: "Before & After",
            process: "The Process",
            faq: "FAQ",
            book: "Book a Session",
        },
        hero: {
            kicker: "BrowsEMS · South Florida",
            states: [
                { eyebrow: "01 · Crafted", title: "Brows, refined.", caption: "Hand-drawn, hair-stroke microblading by South Florida's master artists." },
                { eyebrow: "02 · Sculpted", title: "Wake up flawless.", caption: "Microshading, lip blush & ombré brows — long-lasting, beautifully natural." },
                { eyebrow: "03 · Booked", title: "Your appointment, secured.", caption: "Reserve your seat with a small deposit. Lock in your date in under a minute." },
            ],
            cta: "Book a Session",
            secondaryCta: "Explore Services",
            scrollHint: "Scroll to play",
        },
        services: {
            kicker: "Master services",
            title: "What We Do",
            cursive: "the craft",
            sub: "Semi-permanent brow & lip enhancements by certified artists. Every service includes a private consult, custom mapping, and a 6-week complimentary retouch invitation.",
            bookBtn: "Reserve",
            from: "from",
            depositLabel: "Deposit",
        },
        ribbon: "Crafted brows, confident faces. Wake up ready, every single morning.",
        process: {
            kicker: "How it works",
            title: "From Consult to Crowned",
            cursive: "step by step",
            steps: [
                { tag: "01", title: "Private Consult", copy: "We map your face shape, discuss your routine, and design brows that feel like you." },
                { tag: "02", title: "The Session", copy: "Numbing cream, gentle technique, and 2-3 hours of artistry. You'll watch every step in the mirror." },
                { tag: "03", title: "The 6-Week Retouch", copy: "Your free perfecting visit. We refine color, symmetry, and detail once your skin has healed." },
            ],
        },
        artists: {
            kicker: "Our team",
            title: "Master Artists",
            cursive: "the team",
            sub: "Licensed, certified, and obsessed with brows. Choose the artist you connect with — every member of the BrowsEMS team is trained in the same signature techniques.",
            bookCta: "Book with",
        },
        gallery: {
            kicker: "Real clients",
            title: "Before & After",
            cursive: "transformations",
            sub: "A small selection of recent client work. Every brow is custom-mapped for the face it lives on.",
            before: "Before",
            after: "After",
        },
        testimonials: {
            kicker: "What clients say",
            title: "Five-star love",
            cursive: "kind words",
        },
        faq: {
            kicker: "Good to know",
            title: "Frequently Asked",
            cursive: "your questions",
            items: [
                {
                    q: "How long does microblading last?",
                    a: "Typically 1–2 years before a color refresh. Skin type, sun exposure, and skincare routine all affect longevity. A yearly touch-up keeps brows looking freshly done.",
                },
                {
                    q: "Does it hurt?",
                    a: "Most clients describe it as a faint scratching sensation. We apply a topical numbing cream before and during the session for maximum comfort.",
                },
                {
                    q: "How should I prepare for my appointment?",
                    a: "Avoid caffeine, alcohol, and blood-thinners for 24 hours. Skip retinol, glycolic acid, and brow tinting for 1 week. Arrive with clean skin (no makeup on the brow area).",
                },
                {
                    q: "Why is the deposit non-refundable?",
                    a: "Your deposit reserves the studio time and your artist's day. It is fully credited toward your service total. If you need to reschedule with 72+ hours notice, your deposit transfers to your new date.",
                },
                {
                    q: "What is the difference between microblading and microshading?",
                    a: "Microblading creates fine, hair-like strokes for a natural, brushed look. Microshading adds soft pixel-style shading for a fuller, makeup-finished effect. Combo Brows blend both.",
                },
                {
                    q: "Am I a candidate?",
                    a: "Most healthy adults are. Pregnant or nursing clients, those on Accutane within the last 6 months, or anyone with certain skin conditions should consult before booking.",
                },
            ],
        },
        location: {
            kicker: "Visit us",
            title: "The Studio",
            cursive: "south florida",
            address: "1234 Atlantic Ave, Suite 200 · Boca Raton, FL 33432",
            hoursTitle: "Hours",
            hours: [
                { d: "Tue – Fri", t: "10:00 AM – 7:00 PM" },
                { d: "Saturday", t: "9:00 AM – 5:00 PM" },
                { d: "Sun – Mon", t: "Closed" },
            ],
            phone: "(561) 555-2438",
            email: "hello@browsems.com",
            directions: "Get directions",
        },
        booking: {
            kicker: "Reserve your seat",
            title: "Book a Session",
            cursive: "lock it in",
            sub: "Pick your service, your artist, and your date. A small deposit secures your appointment and is credited toward your total.",
            fields: {
                name: "Your name",
                email: "Email",
                phone: "Phone",
                service: "Service",
                artist: "Artist (optional)",
                date: "Preferred date",
                time: "Preferred time (optional)",
                notes: "Notes (optional)",
                anyArtist: "Any available",
            },
            depositLine: "Deposit",
            depositSuffix: "(applied to service total)",
            cta: "Continue to deposit",
            redirecting: "Redirecting to secure payment…",
            err: "Could not start checkout. Please try again.",
            successTitle: "You're booked!",
            successCopy: "Thank you — your deposit is received and your spot is held. We'll email you within 24 hours to confirm the exact time slot.",
            successCta: "Back to home",
            pendingTitle: "Confirming your payment…",
            pendingCopy: "This usually takes a few seconds.",
            cancelTitle: "Payment cancelled",
            cancelCopy: "No charge was made. Your time slot is released. You can try again whenever you're ready.",
            cancelCta: "Try again",
        },
        newsletter: {
            title: "Stay in the studio loop",
            copy: "First access to new artists, promotions, and brow care tips — straight to your inbox.",
            placeholder: "Your email",
            cta: "Subscribe",
            ok: "You're on the list ✨",
            err: "Something went wrong. Please try again.",
        },
        contact: {
            title: "Have a question?",
            copy: "Send us a note. Our front desk replies within 1 business day.",
            name: "Your name",
            email: "Email",
            subject: "Subject (optional)",
            message: "Your message…",
            cta: "Send message",
            ok: "Message received — we'll be in touch 💌",
            err: "Could not send your message. Please try again.",
        },
        footer: {
            tagline: "South Florida's master microblading studio. Brows crafted by hand, for the face they live on.",
            services: "Services",
            studio: "Studio",
            help: "Help",
            links: {
                services: ["Microblading", "Microshading", "Combo Brows", "Lip Blush", "6-Week Touch-Up"],
                studio: ["Master Artists", "Before & After", "The Process", "Visit Us", "Reviews"],
                help: ["FAQ", "Aftercare", "Reschedule Policy", "Contact", "Gift Cards"],
            },
            rights: "© 2025 BrowsEMS · South Florida. All rights reserved.",
            badge: "Licensed · Certified · Bloodborne Pathogen Trained",
        },
    },
    es: {
        promo: "Estudio máster de South Florida · Microblading · Microshading · Lip Blush",
        nav: {
            services: "Servicios",
            artists: "Artistas",
            gallery: "Antes y Después",
            process: "El Proceso",
            faq: "Preguntas",
            book: "Reservar",
        },
        hero: {
            kicker: "BrowsEMS · South Florida",
            states: [
                { eyebrow: "01 · Diseñadas", title: "Cejas, refinadas.", caption: "Microblading pelo a pelo hecho a mano por nuestras artistas máster de South Florida." },
                { eyebrow: "02 · Esculpidas", title: "Despierta perfecta.", caption: "Microshading, lip blush y cejas ombré — de larga duración y bellamente naturales." },
                { eyebrow: "03 · Reservadas", title: "Tu cita, asegurada.", caption: "Reserva tu lugar con un depósito pequeño. Tu fecha queda fija en menos de un minuto." },
            ],
            cta: "Reservar sesión",
            secondaryCta: "Ver servicios",
            scrollHint: "Desplázate para reproducir",
        },
        services: {
            kicker: "Servicios máster",
            title: "Lo que hacemos",
            cursive: "el oficio",
            sub: "Realces semipermanentes de cejas y labios por artistas certificadas. Cada servicio incluye consulta privada, mapeo personalizado y una invitación gratuita al retoque de 6 semanas.",
            bookBtn: "Reservar",
            from: "desde",
            depositLabel: "Depósito",
        },
        ribbon: "Cejas hechas a mano, rostros con confianza. Despierta lista, cada mañana.",
        process: {
            kicker: "Cómo funciona",
            title: "De la consulta a la corona",
            cursive: "paso a paso",
            steps: [
                { tag: "01", title: "Consulta privada", copy: "Mapeamos tu rostro, conversamos tu rutina y diseñamos cejas que se sienten tuyas." },
                { tag: "02", title: "La sesión", copy: "Crema anestésica, técnica suave, y 2-3 horas de arte. Verás cada paso en el espejo." },
                { tag: "03", title: "Retoque de 6 semanas", copy: "Tu visita gratuita de perfeccionamiento. Afinamos color, simetría y detalle." },
            ],
        },
        artists: {
            kicker: "Nuestro equipo",
            title: "Artistas Máster",
            cursive: "el equipo",
            sub: "Licenciadas, certificadas y obsesionadas con las cejas. Elige la artista con la que conectes — todas usan las mismas técnicas firma de BrowsEMS.",
            bookCta: "Reservar con",
        },
        gallery: {
            kicker: "Clientas reales",
            title: "Antes y Después",
            cursive: "transformaciones",
            sub: "Una pequeña selección de trabajo reciente. Cada ceja se diseña a medida del rostro que la lleva.",
            before: "Antes",
            after: "Después",
        },
        testimonials: {
            kicker: "Lo que dicen",
            title: "Amor cinco estrellas",
            cursive: "palabras lindas",
        },
        faq: {
            kicker: "Bueno saber",
            title: "Preguntas frecuentes",
            cursive: "tus preguntas",
            items: [
                {
                    q: "¿Cuánto dura el microblading?",
                    a: "Generalmente entre 1 y 2 años antes de necesitar refresco de color. La piel, el sol y tu rutina de skincare afectan la duración. Un retoque anual mantiene las cejas frescas.",
                },
                {
                    q: "¿Duele?",
                    a: "La mayoría describe una sensación de leve rasguño. Aplicamos crema anestésica antes y durante la sesión para máximo confort.",
                },
                {
                    q: "¿Cómo me preparo para mi cita?",
                    a: "Evita cafeína, alcohol y diluyentes sanguíneos 24h antes. Suspende retinol, ácido glicólico y tintes de cejas por 1 semana. Llega con piel limpia, sin maquillaje en cejas.",
                },
                {
                    q: "¿Por qué el depósito no es reembolsable?",
                    a: "Tu depósito reserva el tiempo del estudio y de tu artista. Se acredita totalmente al monto del servicio. Si reagendas con 72+ horas de aviso, tu depósito se transfiere a tu nueva fecha.",
                },
                {
                    q: "¿Cuál es la diferencia entre microblading y microshading?",
                    a: "El microblading hace trazos finos tipo pelo, look natural. El microshading agrega sombreado tipo polvo para un efecto más completo, como maquillaje. Combo une ambos.",
                },
                {
                    q: "¿Soy candidata?",
                    a: "La mayoría de adultos sanos sí. Clientas embarazadas, en lactancia, con Accutane en los últimos 6 meses o ciertas condiciones de piel deben consultar antes de reservar.",
                },
            ],
        },
        location: {
            kicker: "Visítanos",
            title: "El Estudio",
            cursive: "south florida",
            address: "1234 Atlantic Ave, Suite 200 · Boca Raton, FL 33432",
            hoursTitle: "Horario",
            hours: [
                { d: "Mar – Vie", t: "10:00 AM – 7:00 PM" },
                { d: "Sábado", t: "9:00 AM – 5:00 PM" },
                { d: "Dom – Lun", t: "Cerrado" },
            ],
            phone: "(561) 555-2438",
            email: "hello@browsems.com",
            directions: "Cómo llegar",
        },
        booking: {
            kicker: "Reserva tu lugar",
            title: "Reservar una sesión",
            cursive: "asegura tu fecha",
            sub: "Elige tu servicio, tu artista y tu fecha. Un depósito pequeño asegura tu cita y se acredita al total del servicio.",
            fields: {
                name: "Tu nombre",
                email: "Correo",
                phone: "Teléfono",
                service: "Servicio",
                artist: "Artista (opcional)",
                date: "Fecha preferida",
                time: "Hora preferida (opcional)",
                notes: "Notas (opcional)",
                anyArtist: "Cualquier disponible",
            },
            depositLine: "Depósito",
            depositSuffix: "(se acredita al total del servicio)",
            cta: "Continuar al depósito",
            redirecting: "Redirigiendo al pago seguro…",
            err: "No se pudo iniciar el pago. Inténtalo de nuevo.",
            successTitle: "¡Lista, tu lugar está reservado!",
            successCopy: "Gracias — recibimos tu depósito y tu lugar está apartado. Te enviaremos correo en 24h para confirmar la hora exacta.",
            successCta: "Volver al inicio",
            pendingTitle: "Confirmando tu pago…",
            pendingCopy: "Suele tardar unos segundos.",
            cancelTitle: "Pago cancelado",
            cancelCopy: "No se realizó ningún cargo. Tu horario se libera. Puedes intentarlo de nuevo cuando quieras.",
            cancelCta: "Intentar otra vez",
        },
        newsletter: {
            title: "Mantente en el loop",
            copy: "Acceso anticipado a nuevas artistas, promociones y consejos para tus cejas — directo a tu inbox.",
            placeholder: "Tu correo",
            cta: "Suscribirme",
            ok: "Estás en la lista ✨",
            err: "Algo salió mal. Inténtalo de nuevo.",
        },
        contact: {
            title: "¿Tienes una pregunta?",
            copy: "Envíanos un mensaje. Nuestra recepción responde en 1 día hábil.",
            name: "Tu nombre",
            email: "Correo",
            subject: "Asunto (opcional)",
            message: "Tu mensaje…",
            cta: "Enviar mensaje",
            ok: "Mensaje recibido — pronto te contactamos 💌",
            err: "No se pudo enviar tu mensaje. Inténtalo de nuevo.",
        },
        footer: {
            tagline: "Estudio máster de microblading en South Florida. Cejas hechas a mano, para el rostro que las lleva.",
            services: "Servicios",
            studio: "Estudio",
            help: "Ayuda",
            links: {
                services: ["Microblading", "Microshading", "Combo Brows", "Lip Blush", "Retoque 6 semanas"],
                studio: ["Artistas Máster", "Antes y Después", "El Proceso", "Visítanos", "Reseñas"],
                help: ["Preguntas frecuentes", "Cuidados posteriores", "Política de reagendado", "Contacto", "Tarjetas regalo"],
            },
            rights: "© 2025 BrowsEMS · South Florida. Todos los derechos reservados.",
            badge: "Licenciada · Certificada · Capacitada en patógenos hemáticos",
        },
    },
};

export const supportedLocales = [
    { code: "en", label: "EN" },
    { code: "es", label: "ES" },
];
